import React, { FC, ReactNode } from 'react';

import styled from '@emotion/styled';
import { compose, margin, textAlign, MarginProps, TextAlignProps } from '@lucid/theme';

import { Component } from '../../types/types';
import Heading, { HeadingProps } from '../heading/heading';
import Text, { TextProps } from '../text/text';

export interface CardSubtitleProps extends MarginProps, TextAlignProps {
  /** The children to be rendered with the Card.Subtitle. */
  children?: ReactNode;
  /** Checks if the title should use the typography variants or the heading variants. */
  isText?: boolean;
  /** The available variants for the Card.Subtitle component. */
  variant?: Component.Type['Typography'];
}

const cardSubtitleStyleProps = compose(margin, textAlign);

const HeadingCardSubtitle = styled(Heading)<HeadingProps>(
  {
    label: 'headingCardSubtitle',
  },
  cardSubtitleStyleProps,
);

const TextCardSubtitle = styled(Text)<TextProps>(
  {
    label: 'textCardSubtitle',
  },
  cardSubtitleStyleProps,
);

const Subtitle: FC<CardSubtitleProps> = ({ isText = false, variant, ...rest }) => {
  return isText ? (
    <TextCardSubtitle {...rest} variant={variant} />
  ) : (
    <HeadingCardSubtitle {...rest} variant={variant} />
  );
};

const CardSubtitle: FC<CardSubtitleProps> = ({ isText, variant, ...rest }) => (
  <Subtitle {...rest} isText={isText} variant={variant} />
);

export { CardSubtitle };
export default CardSubtitle;
